<!-- `data-level` has NO consumer inside AutolacUI: no stylesheet, no selector
     and no test of this app keys on it, so a sweep for dead bindings scoped to
     this project reports it as unused. It is not. The E2E page object
     `src/AutolacTests/pages/_shared/components/sidebar.component.ts:24`
     addresses a cascade level by `.menu-flyout[data-level="<n>"]`, and the
     markup offers no other handle for it. Remove the binding and that suite
     breaks from outside this repository, where nothing here would report it. -->
<div #panel
     class="menu-flyout"
     role="menu"
     [attr.data-level]="level"
     [ngStyle]="panelStyle">
  <ul class="menu-flyout__list">
    <li *ngFor="let item of items; let i = index; trackBy: trackByItem"
        role="none"
        class="menu-flyout__row">
      <!-- `tabindex="-1"`: out of the Tab sequence, never out of reach. The
           menu moves the keyboard through these with `focus()`, which works on
           -1, and the whole cascade shares the menubar's single tab stop
           (AC7, D5). A `<button>` is tabbable with nothing written on it, so
           the attribute has to be spelled out to keep it off the sequence. -->
      <button
        #itemBtn
        type="button"
        role="menuitem"
        tabindex="-1"
        [attr.aria-haspopup]="hasChildren(item) ? 'menu' : null"
        [attr.aria-expanded]="hasChildren(item) ? isOpenParent(item) : null"
        [attr.aria-current]="isActiveRoute(item) ? 'page' : null"
        [attr.data-item-id]="itemKey(item)"
        class="menu-flyout__item"
        [class.menu-flyout__item--open]="isOpenParent(item)"
        [class.menu-flyout__item--on-path]="isOnActivePath(item)"
        [class.menu-flyout__item--active]="isActiveRoute(item)"
        [class.menu-flyout__item--module]="isModuleShortcut(item)"
        (click)="onItemClick(item, $event)"
        (keydown)="onItemKeydown(item, $event, i)"
        (mouseenter)="onItemMouseEnter(item, $event)"
        (mouseleave)="onItemMouseLeave()">

        <span class="menu-flyout__icon" *ngIf="item.iconSvg" aria-hidden="true">
          <lucide-icon [name]="item.iconSvg" [size]="16"></lucide-icon>
        </span>

        <ng-container *ngIf="(item.labelKey ? (item.labelKey | translate) : item.label) as label">
          <span class="menu-flyout__label" [appTooltip]="label" tooltipPosition="top">{{ label }}</span>
        </ng-container>

        <span class="menu-flyout__external" *ngIf="showsExternalLaunchIcon(item)" aria-hidden="true">
          <lucide-icon name="external-link" [size]="14"></lucide-icon>
        </span>

        <span class="menu-flyout__chevron" *ngIf="hasChildren(item)" aria-hidden="true">
          <lucide-icon name="chevron-right" [size]="14"></lucide-icon>
        </span>
      </button>
    </li>
  </ul>
</div>

<app-nav-flyout
  *ngIf="activeChild && activeChild.children?.length"
  [items]="activeChild.children!"
  [anchor]="getActiveChildAnchor()"
  [level]="level + 1"
  [activePath]="activePath"
  [currentUrl]="currentUrl"
  [autofocus]="childAutofocus"
  (itemActivated)="onChildItemActivated($event)"
  (closeRequested)="onChildCloseRequested()"
  (closeAllRequested)="onChildCloseAllRequested()">
</app-nav-flyout>
